'use strict';
angular.module('amexReconciliationApp')
  .component('receiptCardInput', {
    bindings: {
      currentBillingCycle: '<',
      onCardChanged: '&'
    },
    templateUrl: 'scripts/views/components/receipt-card-input.html',
    controller: function (TransactionSearchModel,
                          BillingCycleModel,
                          CardRepository,
                          $translate) {
      var self = this;

      self.displayedCardName = '';
      self.cardList = [];

      self.$onChanges = function () {
        fetchCards();
      };

      self.displayCardName = function (card) {
        if(card.decryptedCardNumber) {
          return card.cardMemberName + ' (' + card.decryptedCardNumber + ')';
        } else {
          return card.cardMemberName;
        }
      };

      function fetchCards() {
        var account = TransactionSearchModel.account();
        var endDates = [];
        if(self.currentBillingCycle.endDate) {
          endDates.push(self.currentBillingCycle.endDate);
        } else {
          endDates = _.map(_.filter(BillingCycleModel.billingCycles(), 'endDate'), 'endDate');
        }

        if (TransactionSearchModel.isBcaManager()) {
          CardRepository.findByBca(account.rca, account.bca, endDates)
            .then(processCardResponse);
        } else if (TransactionSearchModel.isAccountingManager()) {
          CardRepository.findByAccountingLine(
            account.siteNumber,
            account.linkKey,
            account.concatValue,
            endDates
          ).then(processCardResponse);
        }
      }

      function processCardResponse(cardsResponse) {
        var allCardmembersName = $translate.instant('receipt.titles.AllCardmembers');

        var cardList = _.cloneDeep(cardsResponse);
        _.forEach(cardList, function(card) {
          card.displayName = self.displayCardName(card);
        });

        var sortedCardList = _.sortBy(cardList, ['displayName']);
        sortedCardList.unshift({
          cardMemberName: allCardmembersName,
          decryptedCardNumber:'',
          displayName: allCardmembersName
        });

        self.cardList = sortedCardList;
        self.displayedCardName = allCardmembersName;
        self.currentCard = self.cardList[0];
        self.onCardChanged({card: self.currentCard});
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/receiptCardInput.js
// module id = 472
// module chunks = 0